import React, { type ReactNode } from 'react';
import {
    type ColumnInfoType,
    type ColumnInfoValueType,
} from 'types/ColumnInfo';

import TextField from '../components/TextField';
import ImageField from '../components/ImageField';
import ListTextField from '../components/ListTextField';
import { useLanguage } from '../context/LanguageContext';
import { APP_HEADER_TITLE_EN, APP_HEADER_TITLE_JA } from '@env';

const addDataToInfoMap = (
    data: Record<string, any>,
    infoMap: ColumnInfoType
): Record<string, any> => {
    const combinedMap: Record<string, any> = {};
    for (const key in infoMap) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
            let value = data[key]; // Add index signature to allow indexing with a string
            if (
                infoMap[key]?.function !== null &&
                infoMap[key]?.function !== undefined
            ) {
                value = infoMap[key].function?.(data[key]); // Add null check before invoking the function
            }
            combinedMap[key] = {
                ...infoMap[key],
                data: value,
            };
        }
    }
    return combinedMap;
};

const branchComponent = (
    key: string,
    value: ColumnInfoValueType
): ReactNode => {
    if (value.type === 'text') {
        return <TextField data={value.data as string | number} />;
    } else if (value.type === 'image') {
        if (value.data?.image) {
            return <ImageField data={value.data as { image: string }} />;
        } else {
            return (
                <ImageField data={{ image: value.data } as { image: string }} />
            );
        }
    } else if (value.type === 'listText') {
        return <ListTextField data={value.data as string[] | number[]} />;
    } else if (value.type === 'hidden') {
        return <></>;
    } else {
        return <></>;
    }
};

const extractHeaderTitle = (): string => {
    const { currentLanguage } = useLanguage();
    const LanguageMap: Record<'en' | 'ja', string> = {
        en: APP_HEADER_TITLE_EN,
        ja: APP_HEADER_TITLE_JA,
    };
    return LanguageMap[currentLanguage as 'en' | 'ja'];
};

export { addDataToInfoMap, branchComponent, extractHeaderTitle };
